import { v4 as uuidv4 } from 'uuid';

import type { SectionMovement, WorkoutSectionData } from './types';

interface EmptySectionInit {
  id?: string;
  letter: string;
  name?: string;
  description?: string;
}

/** Build a fresh WorkoutSectionData with safe defaults. */
export const createEmptySection = ({
  id,
  letter,
  name = '',
  description = '',
}: EmptySectionInit): WorkoutSectionData => ({
  id: id ?? uuidv4(),
  letter,
  name,
  description,
  movements: [],
  scoreEntireSection: false,
  saveAsBenchmark: true,
  levelScaled: false,
  levelRx: false,
  levelRxPlus: false,
});

/**
 * Duplicate a section with fresh IDs. A kept benchmark keeps its id (re-linked); a one-off
 * section-level section clears movements[0].movementId so the copy provisions its own.
 */
export const duplicateSection = (section: WorkoutSectionData): WorkoutSectionData => {
  const relink = section.scoreEntireSection && section.saveAsBenchmark;
  return {
    ...section,
    id: uuidv4(),
    name: section.name ? `${section.name} (Copy)` : '(Copy)',
    movements: section.movements.map(
      (m, i): SectionMovement => ({
        ...m,
        id: uuidv4(),
        movementId: section.scoreEntireSection && i === 0 && !relink ? '' : m.movementId,
      }),
    ),
  };
};
